"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
var qs_1 = require("qs");
var defaultHeaders = {
    "Content-Type": "application/x-www-form-urlencoded",
};
var Http = (function () {
    function Http() {
        this._prefix = '';
        this._headers = {};
        this._cookies = false;
        this._timeout = 30000;
        this._interceptor = function (headers) { return new Promise(function (resolve) { return resolve(headers); }); };
        this._adapter = function (resp) { return new Promise(function (resolve) { return resolve(resp); }); };
    }
    Http.prototype.request = function (path, option, headers, timeout) {
        if (headers === void 0) { headers = {}; }
        var _path = this._prefix + path;
        var _timeout = timeout || this._timeout;
        var _headers = __assign({}, defaultHeaders, this._headers, headers);
        if (this._cookies)
            option.credentials = "include";
        return this._interceptor(_headers)
            .then(function (iheaders) { return Promise.race([
            isomorphic_fetch_1.default(_path, __assign({}, option, { headers: iheaders })),
            new Promise(function (resolve, reject) { return setTimeout(function () { return reject(new Error("Network Timeout")); }, _timeout); })
        ]); })
            .then(function (resp) {
            if (resp.status >= 400) {
                throw new Error('HTTP STATUS ERROR');
            }
            return resp;
        })
            .then(function (resp) {
            try {
                return resp.json();
            }
            catch (e) {
                throw new Error('HTTP JSON ERROR');
            }
        })
            .then(this._adapter);
    };
    Http.prototype.create = function (_a) {
        var _b = _a.prefix, prefix = _b === void 0 ? "" : _b, _c = _a.headers, headers = _c === void 0 ? {} : _c, _d = _a.cookies, cookies = _d === void 0 ? false : _d, _e = _a.timeout, timeout = _e === void 0 ? 30 : _e, _f = _a.interceptor, interceptor = _f === void 0 ? function (headers) { return new Promise(function (resolve) { return resolve(headers); }); } : _f, _g = _a.adapter, adapter = _g === void 0 ? function (resp) { return new Promise(function (resolve) { return resolve(resp); }); } : _g;
        this._prefix = prefix;
        this._headers = headers;
        this._cookies = cookies;
        this._timeout = timeout;
        this._interceptor = interceptor;
        this._adapter = adapter;
    };
    Http.prototype.setHeaders = function (headers) {
        if (headers === void 0) { headers = {}; }
        this._headers = __assign({}, this._headers, headers);
    };
    Http.prototype.get = function (path, params, headers, timeout) {
        if (params === void 0) { params = {}; }
        if (headers === void 0) { headers = {}; }
        return this.request(path + "?" + qs_1.stringify(params), { method: 'GET' }, headers, timeout);
    };
    Http.prototype.post = function (path, params, headers, timeout) {
        if (params === void 0) { params = {}; }
        if (headers === void 0) { headers = {}; }
        return this.request(path, { method: 'POST', body: qs_1.stringify(params) }, headers, timeout);
    };
    Http.prototype.put = function (path, params, headers, timeout) {
        if (params === void 0) { params = {}; }
        if (headers === void 0) { headers = {}; }
        return this.request(path, { method: 'PUT', body: qs_1.stringify(params) }, headers, timeout);
    };
    Http.prototype.delete = function (path, params, headers, timeout) {
        if (params === void 0) { params = {}; }
        if (headers === void 0) { headers = {}; }
        return this.request(path + "?" + qs_1.stringify(params), { method: 'DELETE' }, headers, timeout);
    };
    Http.prototype.json = function (path, params, headers, timeout) {
        if (params === void 0) { params = {}; }
        if (headers === void 0) { headers = {}; }
        return this.request(path, { method: 'POST', body: JSON.stringify(params) }, __assign({}, headers, { 'Content-Type': 'application/json' }), timeout);
    };
    Http.prototype.stream = function (path, params, headers, timeout) {
        if (headers === void 0) { headers = {}; }
        return this.request(path, { method: 'POST', body: params }, __assign({}, headers, { 'Content-Type': 'application/octet-stream' }), timeout);
    };
    return Http;
}());
exports.default = new Http();
//# sourceMappingURL=index.js.map